import { Image } from '@lib/components'

import { stripHtmlTags } from './helpers'
import styles from './styles.module.scss'
import { LinkPreviewProps } from './types'

export const LinkPreview = ({ data }: LinkPreviewProps) => {
  if (!data.imageUrl) return null

  const cleanTitle = stripHtmlTags(data.title)
  const cleanSubTitle = stripHtmlTags(data.subTitle)

  return (
    <a
      className={styles.container}
      href={data.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Image
        url={data.imageUrl}
        alt={data.title}
        className={styles.image}
        template="external"
      />
      <div className={styles.footer}>
        <span className={styles.title}>{cleanTitle}</span>
        {cleanSubTitle && (
          <span className={styles.subTitle}>{cleanSubTitle}</span>
        )}
      </div>
    </a>
  )
}
